// 软电话 SIP 信令地址（唯一推导处，工作台与独立 sip-phone 页共用）。
// FS 的 ws / wss 是两个独立绑定端口，且浏览器禁止 https 页面连明文 ws（混合内容被拦），
// 故按页面协议二选一：
// - https 页面：VITE_SIP_WSS（加密 wss），留空回落 wss://<页面 hostname>:7443；
// - http 页面：VITE_SIP_WS（明文 ws），留空回落旧变量 VITE_SIP_WSS（兼容只配一个变量的存量部署），
//   再留空回落 ws://<页面 hostname>:5066。
// 端口非默认 7443/5066（如 bcybox ws 5166 / wss 17443）或跨机部署时必须显式配置；
// 不要经 nginx L7 反代（sofia 无法沿代理回拨坐席，INVITE 发不出去）。
export function resolveSipSignal(): string {
  const https = location.protocol === 'https:';
  const configured = https
    ? import.meta.env.VITE_SIP_WSS
    : import.meta.env.VITE_SIP_WS || import.meta.env.VITE_SIP_WSS;
  return configured || (https ? `wss://${location.hostname}:7443` : `ws://${location.hostname}:5066`);
}
